<template>
  <el-dialog
    top="50px"
    width="600px"
    :title="`Thêm ${config.extra.name}`"
    :visible="visible"
    :show-close="!callingAPI"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('close')"
  >
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      size="medium"
      label-position="top"
    >
      <el-row
        type="flex"
        align="start"
        class="flex-wrap"
        :gutter="12"
      >
        <el-col
          v-for="field in formFields"
          :key="field.key"
          :lg="24"
          :span="24"
        >
          <FormItem
            :form="form"
            :field="field"
            :disabled="callingAPI"
            :size="'medium'"
          />
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        :disabled="callingAPI"
        size="medium"
        @click="$emit('close')"
      >
        Đóng
      </el-button>
      <el-button
        type="primary"
        :loading="callingAPI"
        size="medium"
        @click="handleConfirm"
        >Lưu</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import FormItem from "@/components/items/FormItem.vue";
import {
  arrayToObject,
  notification,
  convertPayloadData,
} from "@/utils/common";
import commonServices from "@/services/common";
import constants from "@/config/constants";

export default {
  name: "CreateFormPopup",
  components: {
    FormItem
  },
  props: {
    config: Object,
    visible: Boolean,
    moduleInfo: Object,
    moduleField: Object,
  },
  data() {
    return {
      loading: false,
      form: {},
      callingAPI: false,
      fileType: constants.FIELD_TYPE,
    };
  },
  computed: {
    fields() {
      const result = this.config?.extra?.fields || [];
      return result;
    },
    groups() {
      const result = this.config?.extra?.groups || [];
      return result;
    },
    formFields() {
      let createFields = this.fields.filter((f) => f.show.create_form)
      if (this.moduleInfo?.key) {
        if (this.moduleInfo.create_fields?.length > 0) {
          createFields = this.fields.filter((f) => this.moduleInfo.create_fields.includes(f.key))
        } else {
          const moduleGroups = this.moduleInfo?.groups || [];
          const groupFields = this.groups.filter((g) => moduleGroups.includes(g.key)).map((g) => g.fields).flat();
          if (groupFields.length > 0) {
            createFields = this.fields.filter((f) => groupFields.includes(f.key)).slice(0, 3);
          }
        }
      }
      return createFields.sort((a, b) => a.order - b.order);
    },
    payloadData() {
      const data = {
        extra: {
          ...arrayToObject(this.fields),
          ...this.form,
          relations: [],
        },
      };
      return convertPayloadData(this.config.extra.key, data);
    },
    rules() {
      const result = {};
      for (let i = 0; i < this.formFields.length; i++) {
        const field = this.formFields[i];
        const itemRules = [];
        if (field.form.required) {
          itemRules.push({
            required: true,
            message: `${field.name} là trường bắt buộc.`,
            trigger: ["blur", "change"],
          });
        }
        if (field.form.pattern) {
          const dataType = constants.DATA_TYPES.find(
            (t) => t.key === field.form.pattern
          );
          if (dataType) {
            itemRules.push({
              pattern: dataType.pattern,
              message: `${field.name} không hợp lệ.`,
              trigger: ["blur", "change"],
            });
          }
        }
        if (itemRules.length > 0) {
          result[field.key] = itemRules;
        }
      }
      return result;
    },
  },
  beforeMount() {
    this.loadFormData();
  },
  methods: {
    loadFormData() {
      this.form = arrayToObject(this.fields);
      if (this.moduleInfo && this.moduleField) {
        this.form[this.moduleField.key] = this.moduleInfo.key;
      }
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.callingAPI = true;
          commonServices
            .create(this.config.type, {
              ...this.payloadData,
            })
            .then(() => {
              this.callingAPI = false;
              this.$emit("reload");
              this.$emit("close")
              notification(this, "success", "create", this.config.extra.name);
            })
            .catch(() => {
              this.callingAPI = false;
              notification(this, "error", "create", this.config.extra.name);
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
